<div
  *ngIf="!(isLoading$ | async) || program?.playlists; else loading"
  class="table-container bg-transparent md:bg-white shadow-none md:shadow-base rounded"
>
  <div class="header hidden md:flex">
    <div class="name" translate>SCHEDULE.PROGRAMS.NAME</div>
    <div class="type" translate>SCHEDULE.PROGRAMS.TYPE</div>
    <div class="tracks-played" translate>SCHEDULE.PROGRAMS.TRACKS_PLAYED</div>
    <div class="estimation" translate>SCHEDULE.PROGRAMS.ESTIMATED_TIME</div>
  </div>
  <div class="list" rkPerfectScrollbar #list>
    <ng-container *ngIf="trackIntro$ | async as intro">
      <div class="intro-extro-container mb-8">
        <div class="intro-header mobile-title">Intro</div>
        <div class="intro">
          <div class="name ellipsis">
            <span class="tag hidden md:inline">INTRO</span>
            <img [src]="intro.cover" />
            <div class="hidden md:flex">
              {{ formatSchedulerTrack(intro) }}
            </div>
            <div class="flex md:hidden flex-col ellipsis">
              <span class="ellipsis font-bold">
                {{ intro.title }}
              </span>
              <span class="text-gray-darkest">
                {{ intro.artist }}
              </span>
            </div>
          </div>
          <div class="type">-</div>
          <div class="tracks-played">1</div>
          <div class="estimation">{{ intro.duration | bigTimeFormatLetters }}</div>
        </div>
      </div>
    </ng-container>
    <rk-program-details-list-line
      class="playlist"
      *ngFor="let playlist of program.playlists"
      [playlist]="playlist"
      [program]="program"
      [new]="isNew(playlist)"
      [resetScrollAxis]="resetChildScrollAxis"
      (resetAllScrollAxis)="onResetAllScrollAxis()"
    ></rk-program-details-list-line>

    <ng-container *ngIf="trackExtro$ | async as extro">
      <div class="intro-extro-container mt-8">
        <div class="intro-header mobile-title">Extro</div>
        <div class="extro">
          <div class="name ellipsis">
            <span class="tag hidden md:inline">EXTRO</span>
            <img [src]="extro.cover" />
            <div class="hidden md:flex">
              {{ formatSchedulerTrack(extro) }}
            </div>
            <div class="flex md:hidden flex-col ellipsis">
              <span class="ellipsis font-bold">
                {{ extro.title }}
              </span>
              <span class="ellipsis text-gray-darkest">
                {{ extro.artist }}
              </span>
            </div>
          </div>
          <div class="type">-</div>
          <div class="tracks-played">1</div>
          <div class="estimation">{{ extro.duration | bigTimeFormatLetters }}</div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="preview-program hidden md:block relative">
    <rk-button
      [btnStyle]="'flat'"
      [faIcon]="'fa-eye'"
      [label]="'SCHEDULE.PROGRAMS.PREVIEW' | translate"
      (click)="previewProgram()"
    ></rk-button>
  </div>
</div>

<ng-template #loading>
  <rk-loader [center]="true" [isLoading]="true" [size]="60"></rk-loader>
</ng-template>
